import { endOfYear, format, parse, subYears } from "date-fns";
import { Form, Formik } from "formik";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { getNominaActivaComboBox } from "../../../../../redux/actions/nomina";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../commons/formik/FormikAutocomplete";
import FormikCheckbox from "../../../../commons/formik/FormikCheckbox";
import FormikDatePicker from "../../../../commons/formik/FormikDatePicker";
import PuestosFormContainer from "../../../../commons/puestos/PuestosFormContainer";
import SectorFormContainer from "../../../../commons/sectores/SectorFormContainer";
import { StyledResolucion } from "../../../../styled/Prevencion";
import ExamenesMedicosTable from "./ExamenesMedicosTable";
import InformarExamenesFormContainer from "./informarExamenes/InformarExamenesFormContainer";
import { trabajadoresValidation } from "./trabajadoresValidation";

const TrabajadoresForm = ({
  initialValues,
  handleSubmit,
  handleClose,
  idDependenciaEmpleador,
  nomina,
  puestosAsociadosASustancias,
  sustancias,
  setOpenExamenes,
  openExamenes,
  handleOpenExamenesMedicos,
  valuesFormExamenes,
  trabajadores,
}) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const maxFechaIngreso = endOfYear(subYears(new Date(), 1));
  // useScrollIntoViewOnRender(ref);
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={() => trabajadoresValidation(trabajadores)}
    >
      {({ setFieldValue, values }) => (
        <Form>
          <StyledResolucion.GridContainer container>
            <StyledResolucion.DialogGridItem item xs={12} md={6} ref={ref}>
              <FormikAutocomplete
                name="idTrabajador"
                label="Apellido y Nombre"
                fullWidth={true}
                options={nomina}
                getOptions={() => {
                  const fechaPresentacion = new Date().toISOString().split('T')[0];
                  return dispatch(getNominaActivaComboBox(idDependenciaEmpleador, fechaPresentacion));
                }}
                renderOption={(option) =>
                  option.nombre.split(" - Ingreso: ")[0]
                }
                labelOption={(option) => option.nombre.split(" - Ingreso: ")[0]}
                callBack={(e) => {
                  if (e?.nombre) {
                    let [, nombre, cuil, fechaIngreso] = e.nombre.match(
                      /([A-Z,a-z\s]+) \((\d+)\) - Ingreso: ([\d/]+)/
                    );
                    setFieldValue(
                      "fechaIngreso",
                      format(
                        parse(fechaIngreso, "dd/MM/yyyy", new Date()),
                        "MM/dd/yyyy"
                      )
                    );
                    setFieldValue("cuil", cuil);
                    setFieldValue("nombreApellidoTrabajador", nombre);
                  }
                }}
              />
            </StyledResolucion.DialogGridItem>
            <StyledResolucion.DialogGridItem item xs={12} md={6}>
              <FormikDatePicker
                name="fechaIngreso"
                fullWidth
                label="Fecha Ingreso a la Empresa"
                maxDate={maxFechaIngreso}
              />
            </StyledResolucion.DialogGridItem>
            <StyledResolucion.DialogGridItem item xs={12}>
              <SectorFormContainer
                idDependenciaEmpleador={idDependenciaEmpleador}
                callBack={(e) => {
                  setFieldValue("nombreSector", e?.nombre ?? "");
                }}
                add

              />
            </StyledResolucion.DialogGridItem>
            <StyledResolucion.DialogGridItem item xs={12}>
              <PuestosFormContainer
                add
                idDependenciaEmpleador={idDependenciaEmpleador}
                callBack={(e) => {
                  setFieldValue("nombrePuesto", e?.nombre ?? "");
                  setFieldValue("examenes", {});
                }}
              />
            </StyledResolucion.DialogGridItem>
            <StyledResolucion.DialogGridItem item xs={6}>
              <FormikCheckbox name="permanente" label="Permanente" />
            </StyledResolucion.DialogGridItem>

            <StyledResolucion.DialogGridItem item xs={12}>
              <ExamenesMedicosTable
                key={values.idPuesto}
                data={sustancias
                  .filter((s) =>
                    puestosAsociadosASustancias.some(
                      (p) =>
                        p.puesto === values.idPuesto && p.sustancias?.includes(s.id)
                    )
                  )
                  .map((s) => ({ id: s.id }))}
                handleOpenExamenesMedicos={handleOpenExamenesMedicos}
                sustancias={sustancias}
                values={values}
              />
            </StyledResolucion.DialogGridItem>
          </StyledResolucion.GridContainer>

          <StyledResolucion.ButtonContainer>
            <FormikActions handleCancel={handleClose} submit="Guardar" />
          </StyledResolucion.ButtonContainer>
          <InformarExamenesFormContainer
            open={openExamenes}
            handleClose={() => setOpenExamenes(false)}
            fechaIngreso={values.fechaIngreso}
            callback={({ idSustancia, inicioContacto, finContacto, ...otherValues }) => {
              setFieldValue(`examenes.${idSustancia}`, {
                inicioContacto: inicioContacto ?? null,
                finContacto: finContacto ?? null,
                ...otherValues
              });
            }}
            values={valuesFormExamenes}
          />
        </Form>
      )}
    </Formik>
  );
};

export default TrabajadoresForm;
